import {countdownRenderText, formatBalance} from "../utils";
import {Button} from "../components/Button";
import {RoundedModal} from "../components/Modal";
import React from "react";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import closePurple from "../assets/icons/modal/close-purple@2x.png";
import {useDispatch, useSelector} from "react-redux";
import UIState from "../store/uiState";
import Wallet, {selectNFTBalances} from "../store/models/wallet";
import cardNew from "../assets/icons/card/new@2x.png";
import cardSoldOut from "../assets/icons/card/sold-out@2x.png";
import cardExclusive from "../assets/icons/card/exclusive@2x.png";
import _ from "lodash";
import Countdown from "react-countdown";

const renderAvailableFor = (countDownData) => {
    if (countDownData.completed) {
        return (
            <div className={''}>
                Ended
            </div>
        );
    }

    return (
        <div className={''}>
            {`${countdownRenderText(countDownData)}`}
        </div>
    )
}

export const ItemModal = ({item, onApplyItem, onTryOnItem}) => {
    const dispatch = useDispatch();
    const nftBalances = useSelector(selectNFTBalances);
    console.log('[ItemModal] nftBalances == ', nftBalances);
    const ownedAmount = nftBalances[item.contract_address] || 0;
    console.log('[ItemModal] item.contract_address == ', item.contract_address);
    console.log('[ItemModal] ownedAmount == ', ownedAmount);
    console.log('item?.product?.endsAt == ', item?.product?.endsAt)

    const isOwned = ownedAmount > 0;
    const onPurchaseProduct = () => {
        dispatch(Wallet.actions.purchaseProduct(item?.product, 1));
    }

    const onClose = () => {
        console.log('close');
        dispatch(UIState.actions.hideModal());
    }

    console.log('ItemModal', item);

    return (
        <RoundedModal title={null}
                      header={<div>
                          <a onClick={onClose}
                             className={'ItemModal__close'}
                          >
                              <img src={closePurple}/>
                          </a>
                      </div>}
                      className={'ItemModal'}
        >
            <img className={'ItemModal__image'}
                 src={item.image}/>
            <div className={'ItemModal__name'}>
                {item.name}
            </div>
            <div className={'ItemModal__description'}>
                {item.description}
            </div>
            <div className={'ItemModal__tags'}>
                {
                    !_.isNil(item?.product?.endsAt) &&
                    <div className={'ItemModal__time-left-tag'}>
                        <Countdown
                            date={(new Date(item?.product?.endsAt))}
                            renderer={renderAvailableFor}
                        />
                    </div>
                }
                {
                    item.is_new &&
                    <img src={cardNew}
                         className={'ItemModal__new-tag'}
                    />
                }
                {
                    item?.product?.remaining === 0 &&
                    <img src={cardSoldOut}
                         className={'ItemModal__sold-out-tag'}
                    />
                }
                {
                    item?.is_exclusive &&
                    <img src={cardExclusive}
                         className={'ItemModal__exclusive-tag'}
                    />
                }
                {
                    item.show_remaining && !_.isNil(item?.product?.remaining) &&
                    <div className={'ItemModal__remaining-tag'}>
                        <span>
                            {item?.product?.remaining} left
                        </span>
                    </div>
                }
            </div>
            {
                !isOwned &&
                <div className={'ItemModal__buttons'}>
                    <PurchaseButton onClick={onPurchaseProduct}
                                    text={item.price === 0 ? 'Claim' : 'Buy Now'}
                                    price={item.price}
                                    disabled={(item?.product?.remaining === 0) || (item.is_exclusive) || (item?.product?.endsAt && item?.product?.endsAt < (new Date()).getTime())}
                    />
                    <Button className={'ItemModal__try-on-button'}
                            onClick={(e) => {
                                onTryOnItem(item);
                                onClose();
                            }}
                            color={'purple-light'}
                    >

                        TRY-ON!
                    </Button>
                </div>
            }
            {
                isOwned &&
                <div className={'ItemModal__buttons'}>
                    <Button className={'ItemModal__apply-button'}
                            onClick={(e) => {
                                onApplyItem(item);
                                onClose();
                            }}
                            color={'red'}
                            size={'large'}
                    >

                        Apply Now
                    </Button>
                </div>
            }

            <GetMoreGroveButton/>
        </RoundedModal>
    )
}

export default ItemModal;